import styles from './internal-rate-of-return.module.scss';
import { TableHeaderConfig } from 'types/table/TableHeaderConfig.type';
import clsx from 'clsx';
import { InternalRateOfReturnColumns } from 'modules/clients/types/transaction-summary';
import { TableCell } from '@sanlam-glacier/app-common/components';

export const InternalRateOfReturnHeaderData: TableHeaderConfig<InternalRateOfReturnColumns>[] = [
  {
    key: 'internalRateOfReturn',
    label: 'Internal rate of return',
    className: clsx([styles.tableHeader, styles.internalRateHeader]),
    align: TableCell.ALIGN.LEFT
  },
  {
    key: 'placeholder',
    label: '',
    className: clsx([styles.tableHeader, styles.internalRateHeader])
  },
  {
    key: 'specifiedPeriod',
    label: 'Specified period',
    className: clsx(styles.tableHeader),
    align: TableCell.ALIGN.RIGHT
  },
  {
    key: 'oneYear',
    label: '1 year',
    className: clsx(styles.tableHeader),
    align: TableCell.ALIGN.RIGHT
  },
  {
    key: 'threeYears',
    label: '3 years',
    className: clsx(styles.tableHeader),
    align: TableCell.ALIGN.RIGHT
  },
  {
    key: 'fiveYears',
    label: '5 years',
    className: clsx(styles.tableHeader),
    align: TableCell.ALIGN.RIGHT
  }
];